export const SET_ALL_FOIV_THEMES_FETCHING = 'SET_ALL_FOIV_THEMES_FETCHING';
export const SET_ALL_FOIV_THEMES_ERROR = 'SET_ALL_FOIV_THEMES_ERROR';
export const SET_ALL_FOIV_THEMES = 'SET_ALL_FOIV_THEMES';
export const CLEAN_ALL_FOIV_THEMES = 'CLEAN_ALL_FOIV_THEMES';
export const ABORT_ALL_FOIV_THEMES_REQUEST = 'ABORT_ALL_FOIV_THEMES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/AllFOIVThemes/actions.js